<template>
  <FlotoScrollDropdown
    ref="dropdownRef"
    :options="availableColumns"
    avoid-keyboard-navigation
  >
    <template v-slot:trigger="triggerSlotData">
      <slot name="trigger" v-bind="triggerSlotData">
        <span @click="triggerSlotData.toggle">
          <MTooltip>
            <template v-slot:trigger>
              <MButton shape="circle" variant="neutral-lighter" :shadow="false">
                <MIcon name="table" />
              </MButton>
            </template>
            {{ $tc('column') }} {{ $tc('selection') }}
          </MTooltip>
        </span>
      </slot>
    </template>
    <SortableList
      :value="selectedColumns"
      tag="div"
      handle=".drag-handle"
      class="ant-dropdown-menu"
      style="box-shadow: none"
      @update="handleOrderChange"
    >
      <template v-slot:item="{ item }">
        <div class="ant-dropdown-menu-item scroll-dropdown-menu-item flex">
          <MIcon name="arrows" class="cursor-move drag-handle mx-1" />
          <MCheckbox checked @change="changeSelectedColumn($event, item)">
            {{ item.name }}
          </MCheckbox>
        </div>
      </template>
    </SortableList>
    <MDivider class="my-2" />
    <div class="px-3">
      <MInput
        v-model="searchTerm"
        class="search-box"
        auto-focus
        :placeholder="$t('search')"
      >
        <template v-slot:prefix>
          <MIcon name="search" />
        </template>
      </MInput>
    </div>
    <MMenu class="ant-dropdown-menu">
      <MMenuItem
        v-for="item in filteredRemainingColumns"
        :key="item.key"
        class="ant-dropdown-menu-item scroll-dropdown-menu-item flex"
      >
        <MCheckbox
          :checked="false"
          :disabled="item.disabled || maxSelectable <= selectedColumns.length"
          @change="changeSelectedColumn($event, item)"
        >
          {{ item.name }}
        </MCheckbox>
      </MMenuItem>
    </MMenu>
    <template v-slot:after-menu>
      <div class="flex justify-end py-2 px-2">
        <MButton size="small" outline @click="apply">
          {{ $t('apply') }}
        </MButton>
      </div>
    </template>
  </FlotoScrollDropdown>
</template>

<script>
import UniqBy from 'lodash/uniqBy'
import SortableList from '@components/sortable/sortable-list'

export default {
  name: 'ColumnSelector',
  components: { SortableList },
  model: {
    event: 'change',
  },
  props: {
    availableColumns: { type: Array, required: true },
    columnOrder: { type: Array, required: true },
    value: { type: Array, required: true },
    maxSelectable: { type: Number, default: 10 },
  },
  data() {
    return {
      selectedColumns: [],
      searchTerm: '',
    }
  },
  computed: {
    filteredRemainingColumns() {
      if (this.searchTerm) {
        return this.remainingColumns.filter(
          (x) =>
            x.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
        )
      }
      return this.remainingColumns
    },
    remainingColumns() {
      const selectedKeys = this.selectedColumns.map((c) => c.key)
      return this.availableColumns.filter((c) => {
        return selectedKeys.indexOf(c.key) === -1 && c.disabled !== true
      })
    },
    disabledColumns() {
      const selectedKeys = this.columnOrder
      return this.availableColumns.filter((c) => {
        return selectedKeys.indexOf(c.key) >= 0 && c.disabled
      })
    },
  },
  watch: {
    columnOrder: {
      immediate: true,
      handler() {
        this.selectedColumns = this.columnOrder
          .map((c) => {
            return this.availableColumns.find(
              (x) => c === x.key && x.disabled !== true
            )
          })
          .filter(Boolean)
      },
    },
    availableColumns: {
      immediate: true,
      handler() {
        this.selectedColumns = this.columnOrder
          .map((c) => {
            return this.availableColumns.find(
              (x) => c === x.key && x.disabled !== true
            )
          })
          .filter(Boolean)
      },
    },
  },
  methods: {
    handleOrderChange({ items }) {
      this.selectedColumns = items
    },
    isSelected(name) {
      return !!this.selectedColumns.find((c) => c.name === name)
    },
    changeSelectedColumn(isSelected, column) {
      if (isSelected) {
        this.selectedColumns = [...this.selectedColumns, column]
      } else {
        this.selectedColumns = this.selectedColumns.filter(
          (c) => c.key !== column.key
        )
      }
    },
    apply() {
      this.$emit(
        'change',
        UniqBy([...this.disabledColumns, ...this.selectedColumns]),
        'key'
      )
      this.$refs.dropdownRef.hide()
    },
  },
}
</script>
